import moment from "moment";
const Method = {
  convertDateToDDMMYYYY: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY ");
  },
  convertDateToDDMMYYYYHHMM: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY hh:mm ");
  },
  convertDateToDDMMYYYYHHMMAMPM: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY hh:mm A");
  },
  convertDateToDDMMYYYYHHMMA: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY[,] hh:mm a");
  },
  convertDateToDDMMYYYYHOURS: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY [,] HH:mm ");
  },
  checkisSameOrAfter: (date1: string, date2: string) => {
    return moment(date2).isSameOrAfter(date1);
  },
  dayDifference: (date1: string, date2: string) => {
    return moment(date2).diff(date1, "days");
  },
  generateRandomFileName: (filename: any) => {
    const ext = filename.split(".").pop();
    const random = Math.floor(Math.random() * 9000000000000000);
    const timestamp = new Date().getTime().toString();
    return `${timestamp}_${random}.${ext}`;
  },
  convertDateToFormat: (date: any, format: string) => {
    return moment(date).local().format(format);
  },
  getCurrentMonthStartDate: () => {
    return new Date(moment().startOf("month").format("YYYY-MM-DD"));
  },
  getCurrentMonthEndDate: () => {
    return new Date(moment().endOf("month").format("YYYY-MM-DD"));
  },
  getMonth: (date: string, format: any) => {
    return moment(moment(date).month().toString()).format(format);
  },
  convertToMillions: (number: any) => {
    if (isNaN(number)) {
      return "";
    }
    if (number < 1000000) {
      return number.toString();
    }
    const millions = (number / 1000000).toFixed(2);
    return millions + "M";
  },
  getMonthDigits: (date: string) => {
    return moment(date).local().format("MM");
  },
  getYear: (date: string) => {
    return moment(date).local().format("YYYY");
  },
};
export default Method;
